import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import saveRecommendationConfirmDialog from '../dialog.saveRecommendationConfirmDialog';
import controller from './edit-recommendation-dialog.controller';
import template from './edit-recommendation-dialog.html';

/**
 * Validators
 */
import validator1, { name as validatorName1 } from '../messages/recommendation-unique-name.validator.directive';
import validator2, { name as validatorName2 } from '../messages/recommendation-unique-reference-number.validator.directive';

/**
 * Templates
 */
import generalTextTpl from '../messages/recommendation.general-text.messages.html';
import referenceNumberTpl from '../messages/recommendation.reference-number.messages.html';
import nameTpl from '../messages/recommendation.name.messages.html';
import descriptionTpl from '../messages/recommendation.description.messages.html';
import assignedToTpl from '../messages/recommendation.assigned-to.messages.html';
import statusTpl from '../messages/recommendation.status.messages.html';
import businessRiskTpl from '../messages/recommendation.business-risk.messages.html';
import technicalRiskTpl from '../messages/recommendation.technical-risk.messages.html';
import priorityTpl from '../messages/recommendation.priority.messages.html';
import recommendationScoreTpl from '../messages/recommendation.recommendation-score.messages.html';
// recommendation.date.messages.html // <-- unused template

class dialogService {
  getOptions($event, {
    // eslint-disable-next-line max-len
    customerId, auditId, auditIsActive, businessRisks, technicalRisks, priorities, statuses, users, recommendation, addCallback,
  }) {
    return {
      controller,
      controllerAs: 'editRecommendationDialogVM',
      locals: {
        customerId,
        auditId,
        auditIsActive,
        businessRisks,
        technicalRisks,
        priorities,
        statuses,
        users,
        recommendation,
        addCallback,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editRecommendationDialog', [
  alerts,
  amDataService,
  amSharedModelService,
  constants,
  loaderService,
  saveRecommendationConfirmDialog,
  ssDialogService,
])
  .directive(validatorName1, validator1)
  .directive(validatorName2, validator2)
  .service('editRecommendationDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('recommendation.name.messages.html', nameTpl);
    $templateCache.put('recommendation.general-text.messages.html', generalTextTpl);
    $templateCache.put('recommendation.description.messages.html', descriptionTpl);
    $templateCache.put('recommendation.assigned-to.messages.html', assignedToTpl);
    $templateCache.put('recommendation.status.messages.html', statusTpl);
    $templateCache.put('recommendation.business-risk.messages.html', businessRiskTpl);
    $templateCache.put('recommendation.technical-risk.messages.html', technicalRiskTpl);
    $templateCache.put('recommendation.priority.messages.html', priorityTpl);
    $templateCache.put('recommendation.recommendation-score.messages.html', recommendationScoreTpl);
    $templateCache.put('recommendation.reference-number.messages.html', referenceNumberTpl);
  })
  .name;
